import {UserConfigReducerType} from '../actions/types/userConfig.types';
import {SET_USER_CONFIG_ACTION} from '../actions/userConfig.actions';
import {UserConfig} from '../../incase-domain/user';

export interface UserConfigReducerState {
    userConfig: UserConfig;
}
export const preloadedState: UserConfigReducerState = {
    userConfig: {},
};

export const userConfigReducer = (
    state: UserConfigReducerState = preloadedState,
    action: UserConfigReducerType
): UserConfigReducerState => {
    switch (action.type) {
        case SET_USER_CONFIG_ACTION:
            return {...state, userConfig: action.payload};
        default:
            return state;
    }
};
